<template>
  <div v-if="getTotalAmount">
    <!-- MOBILE -->
    <section class="d-md-none">
      <div
        class="bg-overlay"
        :class="proceedToPaySection ? 'overlay' : ''"
      ></div>
      <!-- PROCEED TO PAY BOOKING FOOTER -->
      <div class="mobile-footer">
        <div
          class="mobile-footer-click"
          @click="
            getIsUserLogged === true && getStoreItems.length > 0
              ? action()
              : onHandleOpenModal('signInModal')
          "
        >
          Proceed to pay (₹ {{ parseInt(getTotalAmount.toFixed(2)) }})
        </div>
        <span class="moreInfo" @click="showBookingSummary">
          <img
            src="@/assets/img/icons/info-white.svg"
            alt
          />
         
        </span>
      </div>

      <!-- PROCEED TO PAY BOOKING POPUP -->
      <div
        class="proceedToPayBox"
        :class="proceedToPaySection ? 'show' : 'hide'"
      >
        <div class="pp-body px-4 w-100">
          <div class="section-space-25"></div>

          <p>Payment info</p>
          <!-- <div class="d-flex align-items-center justify-content-between">
            <div>Ticket Price ({{ getSelectedSeats.length }})</div>
            <div>₹{{ getCurPrice }}</div>
          </div> -->
          <!-- <div class="d-flex align-items-center justify-content-between">
            <div>GST @18%</div>
            <div>₹68.40</div>
          </div> -->
          <div v-if="getStoreItems.length > 0">
            <div
              class="d-flex align-items-center justify-content-between"
              v-for="(itemsLoop, itemKey) in getStoreItems"
              :key="itemKey"
            >
              <div>
                {{ itemsLoop && itemsLoop.Item_strDescription }} ({{
                  itemsLoop && itemsLoop.quantity
                }})
              </div>
              <div>
                ₹{{ itemsLoop && itemsLoop.Item_intPrice * itemsLoop.quantity }}
              </div>
            </div>
          </div>
          <hr />
          <div class="d-flex align-items-center justify-content-between">
            <div>GRAND TOTAL</div>
            <div class="font-weight-bold">
              ₹ {{ parseInt(getTotalAmount.toFixed(2)) }}
            </div>
          </div>

          <div class="section-space-25"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  props: {
    action: {
      type: Function
    }
  },
  data() {
    return {
      proceedToPaySection: false
    };
  },
  computed: {
    ...mapGetters([
      "getSelectedSeats",
      "getBookingSummaryMovie",
      "getBookingSummarySession",
      "getIsUserLogged",
      "getLoggedUser",
      "getOrderID",
      "getTransactionID",
      "getReservationID",
      "getLocation",
      "getCurPrice",
      "getPromoSuccess",
      "getPromoCode",
      "getPromoAmount",
      "getStoreItems",
      "getTotalAmount",
      "getFndCinemaName",
      "getOnlyFndBooking",
      "getPrice_curPrice"
    ])
  },
  methods: {
    actionTest() {
      console.log("action test");
    },
    ...mapActions([
      "handleSeatSelection",
      "reserveSeats",
      "setMovieAndSession",
      "onHandleOpenModal",
      "cancelTransaction",
      "clearBookingSummaryStore"
    ]),
    showBookingSummary: function() {
      this.proceedToPaySection = !this.proceedToPaySection;
    }
  }
};
</script>

<style>
.bg-overlay.overlay::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  height: 100%;
  width: 100%;
  background: #202020;
  opacity: 0.2;
}
.proceedToPayBox {
  position: fixed;
  padding-bottom: 57px;
  bottom: 0;
  width: 100%;
  z-index: 99;
  border-radius: 5px 5px 0px 0px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px 5px 0px 0px;
  transform-origin: bottom;
  transform: scaleY(0);
  transition: 0.4s ease-in;
}

.proceedToPayBox.show {
  transform: scaleY(1);
  transition: 0.4s ease-out;
  color: #000;
  background: #fff !important;
  border: 1px solid #fff;
}

.proceedToPayBox.hide .pp-body {
  transform: scaleY(0);
  transition: 0.1s;
}

.proceedToPayBox.show .pp-body {
  transform: scaleY(1);
  transition: 0.6s;
  color: black;
}

.moreInfo {
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/partials/onlyFndProceedToPay.vue